import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type MarkMiscellaneousDTO = {
  fileId: number;
  misc: boolean;
};

export const markMiscellaneous = ({
  fileId,
  misc,
}: MarkMiscellaneousDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { misc },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useMarkMiscellaneousOptions = {
  fileId: number;
  config?: MutationConfig<typeof markMiscellaneous>;
};

export const useMarkMiscellaneous = ({ fileId, config }: useMarkMiscellaneousOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);
    },
    ...config,
    mutationFn: ({ misc }) => markMiscellaneous({ fileId, misc }),
  });
};
